// "Back to reports" above a report page. The shell decides when it shows
// (lib/reportsBackLink.ts); styling follows the Cockpit back-link standard:
// top-left, ArrowLeft, muted ink.

import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function ReportsBackLink() {
  return (
    <Link
      to="/reports"
      className="text-sm text-amp-ink-muted hover:text-amp-ink dark:text-amp-dark-ink-muted dark:hover:text-amp-dark-ink inline-flex items-center gap-1 mb-3"
    >
      <ArrowLeft className="h-3 w-3" /> Back to reports
    </Link>
  );
}
